import React, {useState} from "react";
import { IProfile } from '../../../interface/IProfile.ts';
import { useProfileApi } from '../../../features/auth/hooks/use-profile-api.ts'
import { ApiResponseType } from "../../../features/api/types.ts";
import { iso3166 } from "../../../static/iso3166.js";
import { NavLink } from "react-router";
import Button from "../../Form/Button.tsx";
import '../../../scss/components/TabContactBusiness.scss';

const TabPersonalData = ({
    profile,
    setProfile
}:{
    profile:IProfile
    setProfile: Function
}) => {
    const [isMailLoading, setIsMailLoading] = useState<boolean>(false);
    const [isPhoneLoading, setIsPhoneLoading] = useState<boolean>(false);
    const [isAddressLoading, setIsAddressLoading] = useState<boolean>(false);

    const [responseMessage, setResponseMessage] = useState<string>('');
    const [responseMessageClass, setResponseMessageClass] = useState<string>('');
    const [savedArea, setSavedArea] = useState<number>(0);
    const { postProfile } = useProfileApi();

    const privateAdressCompleteness = [profile.private_address,profile.private_city,profile.private_zip,profile.private_country].filter(x=>x).length;
    const companyAdressCompleteness = [profile.company_address,profile.company_city,profile.company_zip,profile.company_country].filter(x=>x).length;

    const handleChange = (source:string, value:string) => {
        if (isMailLoading || isPhoneLoading || isAddressLoading) {
            return false;
        }
        setResponseMessage('');
        setResponseMessageClass('');
        let formData = {};
        switch (source) {
            case 'mail':
                setIsMailLoading(true);
                formData['contact_email'] = profile[value];
                formData['preferred_contact_email_source'] = value;
                break;
            case 'phone':
                setIsPhoneLoading(true);
                formData['contact_phone'] = profile[value];
                formData['preferred_contact_phone_source'] = value;
                break;
            case 'address':
                setIsAddressLoading(true);
                formData['preferred_contact_address_source'] = value;
                formData['contact_address'] = profile[`${value}_address`];
                formData['contact_city'] = profile[`${value}_city`];
                formData['contact_zip'] = profile[`${value}_zip`];
                formData['contact_country'] = iso3166.filter(x => x.value === profile[`${value}_country`])[0].value;
                if (value === 'company') {
                    formData['contact_company'] = profile[`${value}_company`];
                    formData['contact_department'] = profile[`${value}_department`];
                } else {
                    formData['contact_company'] = '';
                    formData['contact_department'] = '';
                }
                break;
        }
        if (Object.keys(formData).length > 0) {
            postProfile(formData).then(res => {
                setIsMailLoading(false);
                setIsPhoneLoading(false);
                setIsAddressLoading(false);
                if (res.type === ApiResponseType.OK) {
                    if (res.payload.success)  {
                        switch (source) {
                            case 'mail':
                                profile['preferred_contact_email_source'] = value;
                                break;
                            case 'phone':
                                profile['preferred_contact_phone_source'] = value;
                                break;
                            case 'address':
                                profile['preferred_contact_address_source'] = value;
                                break;
                        }
                        setResponseMessage('Erfolgreich gespeichert');
                        setResponseMessageClass('success show');
                        setTimeout(() => {
                            setResponseMessage('');
                        }, 5000);
                    }
                } else {
                    let errors = res.payload.errors!;
                    if (!errors.general_error) {
                        let message = 'Fehler. Bitte korrigieren Sie den Fehler und versuchen Sie es erneut.';
                        if (errors.contact_phone) {
                            message = 'Fehler. ' + errors.contact_phone;
                        }
                        setResponseMessage(message);
                        setResponseMessageClass('error show');
                    }
                }
            });
        } else {        
            setIsMailLoading(false);
            setIsPhoneLoading(false);
            setIsAddressLoading(false);
        }
    }


    return (
        <div className="single-tab-item preferred-contact">
            <h6 className="mt-0">Bitte teilen Sie uns mit, über welche E-Mailadresse der FPSB Deutschland mit Ihnen kommunizieren soll.</h6>
            <div className={`box-wrapper${isMailLoading ? ' loading' : ''}`}>
                <div className="loader"></div>
                <div className='contact-item-box'>
                    { profile.private_email && (
                        <Button
                            buttonType='small'
                            type='button'
                            className={profile.preferred_contact_email_source === 'private_email' ? 'outline' : ''}
                            onClick={(e) => {
                                e.preventDefault();
                                handleChange('mail', 'private_email');
                                setSavedArea(1);
                            }}
                        >{profile.preferred_contact_email_source === 'private_email' ? 'gewählt' : 'auswählen'}</Button>
                    ) }
                    <p><strong>Privat:</strong></p>
                    { profile.private_email ? (
                        <p>{ profile.private_email }</p>
                    ) : (
                        <p>Bitte hinterlegen Sie zunächst eine E-Mail im Bereich <NavLink to="/profile/privatedata" end>Private Kontaktdaten</NavLink>.</p>
                    )}
                </div>
                <div className='contact-item-box'>
                    { profile.company_email && (
                        <Button
                            buttonType='small'
                            type='button'
                            className={profile.preferred_contact_email_source === 'company_email' ? 'outline' : ''}
                            onClick={(e) => {
                                e.preventDefault();
                                handleChange('mail', 'company_email');
                                setSavedArea(1);
                            }}
                        >{profile.preferred_contact_email_source === 'company_email' ? 'gewählt' : 'auswählen'}</Button>
                    ) }
                    <p><strong>Geschäftlich:</strong></p>
                    { profile.company_email ? (
                        <p>{ profile.company_email }</p>
                    ) : (
                        <p>Bitte hinterlegen Sie zunächst eine E-Mail im Bereich <NavLink to="/profile/officialdata" end>Geschäftliche Kontaktdaten</NavLink>.</p>
                    )}
                </div>                
            </div>
            { responseMessage && savedArea === 1 && (
                <div className={`message${responseMessageClass ? ' ' + responseMessageClass : ''}`} role="alert" onClick={() => {setResponseMessage('');}}>
                    <span>
                        {responseMessage}
                    </span>
                </div>
            ) }
            <hr />
            <h6>Bitte wählen Sie eine Festnetznummer aus, über die der FPSB Deutschland mit Ihnen kommunizieren soll.</h6>
            <div className={`box-wrapper${isPhoneLoading ? ' loading' : ''}`}>
                <div className="loader"></div>
                <div className='contact-item-box'>
                    { profile.private_mobile && (
                        <Button
                            buttonType='small'
                            type='button'
                            className={profile.preferred_contact_phone_source === 'private_mobile' ? 'outline' : ''}
                            onClick={(e) => {
                                e.preventDefault();
                                handleChange('phone', 'private_mobile');
                                setSavedArea(2);
                            }}
                        >{profile.preferred_contact_phone_source === 'private_mobile' ? 'gewählt' : 'auswählen'}</Button>
                    ) }
                    <p><strong>Privat (Mobil):</strong></p>
                    { profile.private_mobile ? (
                        <p>{ profile.private_mobile }</p>
                    ) : (
                        <p>Bitte hinterlegen Sie zunächst eine Mobilnummer im Bereich <NavLink to="/profile/privatedata" end>Private Kontaktdaten</NavLink>.</p>
                    )}
                </div>
                <div className='contact-item-box'>
                    { profile.private_phone && (
                        <Button
                            buttonType='small'
                            type='button'
                            className={profile.preferred_contact_phone_source === 'private_phone' ? 'outline' : ''}
                            onClick={(e) => {
                                e.preventDefault();
                                handleChange('phone', 'private_phone');
                                setSavedArea(2);
                            }}
                        >{profile.preferred_contact_phone_source === 'private_phone' ? 'gewählt' : 'auswählen'}</Button>
                    ) }
                    <p><strong>Privat (Festnetz):</strong></p>
                    { profile.private_phone ? (
                        <p>{ profile.private_phone }</p>
                    ) : (
                        <p>Bitte hinterlegen Sie zunächst eine Festnetznummer im Bereich <NavLink to="/profile/privatedata" end>Private Kontaktdaten</NavLink>.</p>
                    )}
                </div>
                <div className='contact-item-box'>
                    { profile.company_mobile && (
                        <Button
                            buttonType='small'
                            type='button'
                            className={profile.preferred_contact_phone_source === 'company_mobile' ? 'outline' : ''}
                            onClick={(e) => {
                                e.preventDefault();
                                handleChange('phone', 'company_mobile');
                                setSavedArea(2);
                            }}
                        >{profile.preferred_contact_phone_source === 'company_mobile' ? 'gewählt' : 'auswählen'}</Button>
                    ) }
                    <p><strong>Geschäftlich (Mobil):</strong></p>
                    { profile.company_mobile ? (
                        <p>{ profile.company_mobile }</p>
                    ) : (
                        <p>Bitte hinterlegen Sie zunächst eine Mobilnummer im Bereich <NavLink to="/profile/officialdata" end>Geschäftliche Kontaktdaten</NavLink>.</p>
                    )}
                </div>
                <div className='contact-item-box'>
                    { profile.company_phone && (
                        <Button
                            buttonType='small'
                            type='button'
                            className={profile.preferred_contact_phone_source === 'company_phone' ? 'outline' : ''}
                            onClick={(e) => {
                                e.preventDefault();
                                handleChange('phone', 'company_phone');
                                setSavedArea(2);
                            }}
                        >{profile.preferred_contact_phone_source === 'company_phone' ? 'gewählt' : 'auswählen'}</Button>
                    ) }
                    <p><strong>Geschäftlich (Festnetz):</strong></p>
                    { profile.company_phone ? (
                        <p>{ profile.company_phone }</p>
                    ) : (
                        <p>Bitte hinterlegen Sie zunächst eine Festnetznummer im Bereich <NavLink to="/profile/officialdata" end>Geschäftliche Kontaktdaten</NavLink>.</p>
                    )}
                </div>
            </div>
            { responseMessage && savedArea === 2 && (
                <div className={`message${responseMessageClass ? ' ' + responseMessageClass : ''}`} role="alert" onClick={() => {setResponseMessage('');}}>
                    <span>
                        {responseMessage}
                    </span>
                </div>
            ) }
            <hr />
            <h6>Bitte teilen Sie uns mit, über welche Postadresse der FPSB Deutschland mit Ihnen kommunizieren soll.</h6>
            <div className="box-wrapper">
                <div className="loader"></div>
                <div className={`box-wrapper${isAddressLoading ? ' loading' : ''}`}>
                    <div className='contact-item-box'>
                        { privateAdressCompleteness >= 4 && (
                            <Button
                                buttonType='small'
                                type='button'
                                className={profile.preferred_contact_address_source === 'private' ? 'outline' : ''}
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleChange('address', 'private');
                                    setSavedArea(3);
                                }}
                            >{profile.preferred_contact_address_source === 'private' ? 'gewählt' : 'auswählen'}</Button>
                        )}
                        <p><strong>Privat:</strong></p>
                        { privateAdressCompleteness === 0 && (
                            <p>Bitte hinterlegen Sie zunächst eine Adresse im Bereich <NavLink to="/profile/privatedata" end>Private Kontaktdaten</NavLink>.</p>
                        )}
                        { (privateAdressCompleteness > 0 && privateAdressCompleteness < 4) && (
                            <p>Bitte vervollständigen Sie zunächst Ihre Adresse im Bereich <NavLink to="/profile/privatedata" end>Private Kontaktdaten</NavLink>.</p>
                        )}
                        { privateAdressCompleteness >= 4 && (
                            <p>{ profile.private_address }, {profile.private_zip } { profile.private_city}, { iso3166.filter(x => x.value === profile.private_country)[0].label }</p>
                        )}
                    </div>
                    <div className='contact-item-box'>
                        { companyAdressCompleteness >= 4 && (
                            <Button
                                buttonType='small'
                                type='button'
                                className={profile.preferred_contact_address_source === 'company' ? 'outline' : ''}
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleChange('address', 'company');
                                    setSavedArea(3);
                                }}
                            >{profile.preferred_contact_address_source === 'company' ? 'gewählt' : 'auswählen'}</Button>
                        )}
                        <p><strong>Geschäftlich:</strong></p>
                        { companyAdressCompleteness === 0 && (
                            <p>Bitte hinterlegen Sie zunächst eine Adresse im Bereich <NavLink to="/profile/privatedata" end>Private Kontaktdaten</NavLink>.</p>
                        )}
                        { (companyAdressCompleteness > 0 && companyAdressCompleteness < 4) && (
                            <p>Bitte vervollständigen Sie zunächst Ihre Adresse im Bereich <NavLink to="/profile/privatedata" end>Private Kontaktdaten</NavLink>.</p>
                        )}
                        { companyAdressCompleteness >= 4 && (
                            <p>{ profile.company_company ? profile.company_company + ' - ' : '' }  { profile.company_address }, {profile.company_zip } { profile.company_city}, { iso3166.filter(x => x.value === profile.company_country)[0].label }</p>
                        )}
                    </div>
                </div>
            </div>
            { responseMessage && savedArea === 3 && (
                <div className={`message${responseMessageClass ? ' ' + responseMessageClass : ''}`} role="alert" onClick={() => {setResponseMessage('');}}>
                    <span>
                        {responseMessage}
                    </span>
                </div>
            ) }
        </div>
    )
}

export default TabPersonalData;